/**
 * @generated SignedSource<<8b2150925ed2673cd3cfdf7308bd5059>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoAnswersField_User$data = {
  readonly answers: ReadonlyArray<{
    readonly id: string;
    readonly public: boolean;
    readonly question: {
      readonly rawId: number | null | undefined;
      readonly title: string;
    } | null | undefined;
    readonly url: string;
  }> | null | undefined;
  readonly " $fragmentType": "VideoAnswersField_User";
};
export type VideoAnswersField_User$key = {
  readonly " $data"?: VideoAnswersField_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"VideoAnswersField_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VideoAnswersField_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Video",
      "kind": "LinkedField",
      "name": "answers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "public",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Question",
          "kind": "LinkedField",
          "name": "question",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rawId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3ef37ee488cc39585fb4da07e7775ce0";

export default node;
